import styled from "styled-components";
import { StyledButtonIcon } from "../button-icon/ButtonIcon.style";
import ButtonIcon from "../button-icon/ButtonIcon";
import { getValueFromPixelString } from "../../utils/TokenHelpers";
import { apolloSpaceInsetHalfX } from "@nexthink/apollo-tokens";
export const StyledKebabActionMenu = styled.div.withConfig({ displayName: "StyledKebabActionMenu_APC-7311-productShell", componentId: "sc-p5noec" })(() => ({
    display: "contents",
    [`${StyledButtonIcon}:hover:not([disabled])`]: {
        backgroundColor: "transparent",
    },
}));
export const HiddenButtonIcon = styled(ButtonIcon).withConfig({ displayName: "HiddenButtonIcon_APC-7311-productShell", componentId: "sc-1o7ay8m" })(({ isVisible }) => ({
    "&&": {
        opacity: isVisible ? 1 : 0,
        display: "flex",
        justifyContent: "center",
        // content is 12px by default, ButtonIcon is 20px, so we need this to not extend the content
        margin: `${-1 * getValueFromPixelString(apolloSpaceInsetHalfX)}px 0`,
        "&:focus-within": {
            opacity: 1,
        },
        "&:hover": {
            opacity: 1,
        },
    },
}));
//# sourceMappingURL=KebabActionMenu.style.js.map